import { useTranslation } from 'react-i18next'
import FixedBottom from '@/components/FixedBottom'
import CustomButton from '@/components/CustomButton'

interface StepSuccessProps {
  onGoHome: () => void
}

export default function StepSuccess({ onGoHome }: StepSuccessProps) {
  const { t } = useTranslation()
  
  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 flex flex-col items-center justify-center px-5">
        <img src="/images/my/icons/submit-success.svg" />
        <div className="text-7 font-medium text-[#1D2129] my-4">
          {t('已提交')}
        </div>
        <div className="text-sm font-normal leading-6 text-[#667085] text-center max-w-70">
          {t('我们的团队正在为您完成身份验证验证通过后您即可正常使用相关服务')}
        </div>
      </div>

      {/* 底部按钮 */}
      <FixedBottom className="bg-white">
        <CustomButton onClick={onGoHome}>
          {t('完成')}
        </CustomButton>
      </FixedBottom>
    </div>
  )
}

